exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * @license\n * Copyright Akveo. All Rights Reserved.\n * Licensed under the MIT License. See License.txt in the project root for license information.\n */\n:host {\n  display: block; }\n\n.progress-container {\n  overflow: hidden; }\n\n.progress-value {\n  height: 100%;\n  text-align: center;\n  overflow: hidden; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/dev/FitRadioAdmin2/src/app/@nebular/theme/components/progress-bar/progress-bar.component.scss
// module id = ../../../../../src/app/@nebular/theme/components/progress-bar/progress-bar.component.scss
// module chunks = main